import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { isMobile, wait, Event } from "../../../Helper";
import BankRoll from "../../Components/Game/BankRoll";
import TopBarGames from "../../Components/Game/Addons/TopBar";
import Queue from "../../Components/Game/Queue";
import Table from "./components/Table";
import Engine from "./Engine";
import Game from "./Game";
import Bet from "./Bet";
import Loading from "../Loading";
import "../../../Static/css/videoPoker.css";
import VideoPokerBetStatsPopup from "./Graph";

class Index extends React.Component {
  _Mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: new Engine(),
      padding: "p-1",
      isMobile: isMobile() ? true : false,
      showPopup: false,
    };
    this.handleShowPopUp = this.handleShowPopUp.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  handleShowPopUp() {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
    }));
  }

  componentDidMount() {
    let { engine } = this.state;

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Start Engine
    engine.started = true;

    wait(600).then(() => {
      this.handleResize();
    });
    window.addEventListener("resize", this.handleResize);
  }

  componentWillMount() {
    wait(500).then(() => {
      this._Mounted = true;
    });
  }

  componentWillUnmount() {
    let { engine } = this.state;
    window.removeEventListener("resize", this.handleResize);
    this._Mounted = false;

    // Stop Engine
    engine.started = false;
    engine.off();
  }

  handleResize() {
    let clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;

    if (clientWidth < 1540) {
      this.setState({ col: "col-xl-12" });
      Event.emit("hide_games");
    } else {
      this.setState({ col: "col-xl-9" });
      Event.emit("show_min_games");
    }

    if (this.state.isMobile) {
      this.setState({ padding: "p-0", ovh: "ovh" });
    }
  }

  render() {
    let { col, padding, ovh, isMobile } = this.state;

    const help = (
      <p className="text-white">
        Video poker has many variants, but all are based on one of poker’s
        simplest varieties, five-card draw. You are dealt a five-card poker
        hand, then given one opportunity to keep the cards you wish to keep and
        discard the ones you don’t wish to retain, receiving new cards in
        return. This then makes up your final hand.
        <b>Video Poker Tips & Tricks</b> <br />
        Hit deal to receive your initial five-card poker hand <br />
        Discard cards you don’t deem useful (up to all five can be discarded){" "}
        <br />
        Receive replacement cards from the same ‘virtual deck’.
        <br />
        Any winnings are paid out according to the paytable. <br />
      </p>
    );

    return (
      <>
        <Helmet>
          <title>Video Poker</title>

          <link rel="canonical" href="/videopoker" />
        </Helmet>
        <div>
          {this._Mounted ? (
            <div
              className={`${col} ${padding}`}
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                maxWidth: "3000px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.state.showPopup && (
                <VideoPokerBetStatsPopup
                  onClose={this.handleShowPopUp}
                  engine={this.state.engine}
                />
              )}

              <Row className={"animated fadeIn " + ovh}>
                <div className="d-none">
                  Crypto Video Poker Game Description: {help}
                </div>
                <Col sm={12} className={"m-auto " + col + " " + padding}>
                  {/* mine-container */}

                  <div className="mine-containers">
                    {/* game container */}

                    <div className="game-containers">
                      {/* header */}
                      <div
                        className="game-header"
                        style={{
                          // width: "100%",
                          // height: "100%",  // Use 100vh for full viewport height
                          padding: "3px 10px",
                          backgroundColor: "#17181b",
                          display: "flex",
                          justifyContent: "center", // Center the container horizontally
                          alignItems: "center", // Center the container vertically
                          boxSizing: "border-box", // Ensure padding doesn't affect the width/height
                          opacity: 0.9,
                          // borderTopLeftRadius: "1rem",  // Top-left corner rounded
                          borderTopRightRadius: "1rem", // Top-right corner rounded
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            gap: "10px",
                            // border:"2px solid red",   // Allow wrapping on smaller screens
                          }}
                        >
                          {/* First Circle */}
                          {/* <div
                            className="header-content"
                            style={{
                              borderRadius: "2rem", // Ensure it is circular
                              width: "100%", // Adjust width as a percentage for responsiveness
                              height: "100%", // Fixed height for the div
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center", // Vertically centers content
                              alignItems: "center", // Horizontally centers content
                              textAlign: "center",
                              color: "white",
                              boxSizing: "border-box",
                              flex: "2",
                              padding: "5px",
                              // overflow:"hidden",
                              whiteSpace: "nowrap", // Prevent text from wrapping
                              textOverflow: "ellipsis",
                            }}
                          >
                            <p
                              className="game-header"
                              style={{
                                margin: 0,
                                width: "100%",
                                // border: "2px solid red", // Red border for testing
                                color: "white",
                                borderRadius: "2rem",
                                backgroundColor: "#26272c",
                                padding: "1px", // Add padding to create space around text
                              }}
                            >
                              <span
                                className="game-header"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#43b309",
                                }}
                              >
                                BankRoll
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  padding: "0px 3px",
                                  fontWeight: "bold",
                                  color: "gray",
                                }}
                                className="game-header"
                              >
                                INR
                              </span>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "gray",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                  margin: " 0", // Added margin for separation between the elements
                                }}
                                className="game-header"
                              >
                                <img
                                  src="/assets/images/inr.png"
                                  alt="img"
                                  style={{
                                    width: "21px",
                                    padding: "0px 1px",
                                  }}
                                />
                                <span className="game-header">2842.002</span>
                              </p>
                            </p>
                          </div> */}

                          {/* Second Circle */}
                          {/* <div 
                                        style={{
                                            // border: "2px solid yellow", 
                                            borderRadius: "2rem",  // Ensure it is circular
                                            width: "100%",         // Adjust width as a percentage for responsiveness
                                            height: "100%",      // Fixed height, same as above for uniformity
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center", 
                                            textAlign: "center", 
                                            color: "white", 
                                            fontSize: "15px",
                                            fontWeight:"bold",
                                            padding: "13px",
                                            boxSizing: "border-box",
                                            flex:"3",
                                            backgroundColor: "#26272c",
                                            color:"gray",
                                            overflow:"hidden"
                                        }}
                                        className='fontChange'
                                    >
                            
                                Game results will be displayed here.
                                
                                    </div> */}
                        </div>
                      </div>

                      {/* GAME */}
                      <Card
                        className="mb-0"
                        style={{ backgroundColor: "#17181b" }}
                      >
                        <Card.Body
                          className={"bg-dice-options p-1 animated fadeIn"}
                          id="roll-panel"
                        >
                          <Row>
                            <Col sm={12} md={12} className={"m-auto"}>
                              {isMobile ? (
                                <Table engine={this.state.engine} />
                              ) : (
                                <Game engine={this.state.engine} />
                              )}
                            </Col>
                            <Col sm={12} md={10} className={"m-auto"}>
                              {isMobile ? (
                                <Game engine={this.state.engine} />
                              ) : (
                                <Table engine={this.state.engine} />
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="bet-containers">
                      {/* BET */}
                      <Card
                        className="mb-0 bet-body"
                        style={{
                          backgroundColor: "#17181b",
                          borderRight: "1px solid #222328",
                          padding: "5px",
                          height: "100%",
                        }}
                      >
                        <Card.Body className={padding}>
                          <Row>
                            <Col sm={12} md={12} className={"m-auto"}>
                              <Bet engine={this.state.engine} />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  {/* BANKROLL */}
                  <Card
                    className="mb-0"
                    style={{
                      backgroundColor: "#17181b",
                      borderBottomLeftRadius: "1rem",
                      borderBottomRightRadius: "1rem",
                    }}
                  >
                    <Card.Body className="px-2 py-3">
                      <Row>
                        <Col md={6} className={"col-6 text-left"}>
                          <BankRoll game={"videopoker"} />
                        </Col>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            right: "1px",
                            width: "40%",
                          }}
                        >
                          <Col
                            md={6}
                            className={"col-6 text-right"}
                            style={{
                              display: "flex",
                              gap: "8px",
                              justifyContent: "flex-end",
                              textAlign: "center",
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ display: "flex" }}>
                              <TopBarGames
                                help={help}
                                image="/assets/images/covers_new/____hilo.png"
                              />
                              <div
                                onClick={this.handleShowPopUp}
                                style={{
                                  alignItems: "center",
                                  height: "37px",
                                  width: "37px",
                                  borderRadius: "5px",
                                  backgroundColor: "#17181b",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    fontWeight: "900",
                                  }}
                                  src="/assets/images/nanoicons/nanoswap.png"
                                  alt="Swap"
                                />
                              </div>
                            </div>
                          </Col>
                        </div>
                      </Row>
                    </Card.Body>
                  </Card>

                  {/* QUEUE */}
                  <Card
                    className="mb-5 mt-5"
                    style={{
                      borderRadius: "1rem",
                      backgroundColor: "#17181b",
                    }}
                  >
                    <Card.Body className="p-1">
                      <Row>
                        <Col sm={12} md={12} className={"m-auto px-1"}>
                          <Queue t={this.props.t} game={"videopoker"} />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

export default Index;
